import {
  IBookingListParams,
  IBookingReasonPayload,
  ICompleteBookingPayload,
  ICreateBookingPayload,
  IProposeBookingTimePayload
} from '@pharvio/core/shared';

export class LoadBookings {
  static readonly type = '[Bookings] Load Bookings';
  constructor(public params: IBookingListParams = {}) {}
}

export class LoadBooking {
  static readonly type = '[Bookings] Load Booking';
  constructor(
    public id: string,
    /** Skips the "already on screen" shortcut — what a refetch dispatches. */
    public reload = false
  ) {}
}

export class CreateBooking {
  static readonly type = '[Bookings] Create Booking';
  constructor(public payload: ICreateBookingPayload) {}
}

export class ConfirmBooking {
  static readonly type = '[Bookings] Confirm Booking';
  constructor(public id: string) {}
}

export class ProposeBookingTime {
  static readonly type = '[Bookings] Propose Booking Time';
  constructor(
    public id: string,
    public payload: IProposeBookingTimePayload
  ) {}
}

export class StartBooking {
  static readonly type = '[Bookings] Start Booking';
  constructor(public id: string) {}
}

export class CompleteBooking {
  static readonly type = '[Bookings] Complete Booking';
  constructor(
    public id: string,
    public payload: ICompleteBookingPayload
  ) {}
}

export class DeclineBooking {
  static readonly type = '[Bookings] Decline Booking';
  constructor(
    public id: string,
    public payload: IBookingReasonPayload
  ) {}
}

export class NoShowBooking {
  static readonly type = '[Bookings] No-Show Booking';
  constructor(public id: string) {}
}

export class CancelBooking {
  static readonly type = '[Bookings] Cancel Booking';
  constructor(
    public id: string,
    public payload: IBookingReasonPayload
  ) {}
}

export class SelectBooking {
  static readonly type = '[Bookings] Select Booking';
  constructor(public id: string | null) {}
}
